/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

export const mcpScopes = [
  "read",
  "write",
] as const;

export type MCPScope = (typeof mcpScopes)[number];
